// src/pages/services-overview/servicesData.js
export const servicesData = [
  {
    slug: "obra-civil",
    name: "OBRA CIVIL",
    description: `Desarrollamos proyectos de obra civil con soluciones estructurales y constructivas sólidas, cumpliendo con los más altos estándares técnicos y de seguridad. Nuestro alcance incluye:`,
    bullets: [
      "Construcción de estructuras en concreto reforzado e industrializado (IP).",
      "Montaje de elementos prefabricados estructurales.",
      "Cerramientos en mampostería estructural o no estructural, y sistemas en drywall según requerimientos técnicos.",
      "Trabajos en alturas para estructuras, cubiertas o cerramientos especiales.",
      "Instalación y conducción de redes de gases medicinales.",
      "Montaje de falsos techos técnicos (no decorativos).",
      "Excavaciones, cimentaciones y movimientos de tierra.",
      "Instalación de canalizaciones embebidas para redes eléctricas e hidrosanitarias.",
      "Construcción de muros de contención y estructuras auxiliares.",
    ],
  },
  {
    slug: "acabados",
    name: "ACABADOS",
    description: `Ofrecemos soluciones completas en acabados arquitectónicos, cuidando cada detalle para garantizar estética, funcionalidad y confort en los espacios. Contamos con experiencia en la aplicación de diversos materiales y técnicas, adaptándonos a las necesidades de cada proyecto. Nuestros servicios incluyen:`,
    bullets: [
      "Instalación de ventanería de todo tipo: aluminio, PVC, vidrio templado, entre otros.",
      "Suministro e instalación de puertas en madera, lámina metálica o vidrio.",
      "Revestimientos y enchapes en pisos y paredes, con materiales cerámicos, porcelánicos, piedra natural, entre otros.",
      "Montaje de cielos rasos en drywall, superboard, PVC o madera, según el diseño y uso del espacio.",
      "Aplicación de recubrimientos especiales según especificaciones técnicas o decorativas.",
    ],
  },
  {
    slug: "mantenimiento-locativo",
    name: "MANTENIMIENTO LOCATIVO",
    description: `Ofrecemos servicios integrales de mantenimiento locativo, orientados a conservar, recuperar y mejorar las condiciones funcionales y estéticas de todo tipo de espacios. Nuestro equipo ejecuta intervenciones con materiales y técnicas de alta calidad para prolongar la vida útil de las instalaciones. Dentro de nuestras especialidades se encuentran:`,
    bullets: [
      "Resane y pintura general de paredes, cielos rasos, puertas y marcos.",
      "Restauración y cambio de pisos: enchapes, baldosas, madera, pintura especializada, pisos laminados, entre otros.",
      "Reparación y mantenimiento de cubiertas: placas, planchas metálicas o fibrocemento.",
      "Servicios de mantenimiento hidráulico general (plomería): cambio de griferías, corrección de fugas, adecuación de redes.",
      "Impermeabilización de techos, placas y muros, con aplicación de productos técnicos según diagnóstico previo.",
    ],
  },
  {
    slug: "comunicaciones",
    name: "COMUNICACIONES",
    description: `Suministramos, instalamos y damos soporte a soluciones tecnológicas orientadas a optimizar la comunicación, seguridad y eficiencia operativa en entornos administrativos, institucionales y asistenciales. Nuestra oferta incluye:`,
    bullets: [
      "Equipos de cómputo de escritorio, portátiles y periféricos.",
      "Centrales telefónicas y sistemas de comunicación IP.",
      "Equipos de radiocomunicaciones para redes internas y externas.",
      "Dispositivos para el procesamiento, reproducción y transcripción de información.",
      "Sistemas de videovigilancia (CCTV) con cámaras análogas o digitales.",
      "Soluciones de control de acceso para zonas restringidas o seguras.",
      "Mobiliario especializado para puestos de trabajo administrativos y áreas asistenciales.",
      "Equipos de comunicaciones e informática adaptados a las necesidades del cliente.",
    ],
  },
  {
    slug: "hidrosanitarios",
    name: "HIDROSANITARIOS",
    description: `Diseñamos e implementamos soluciones hidrosanitarias con enfoque sostenible, promoviendo el uso eficiente del agua y el cumplimiento normativo. Nuestro trabajo incluye la instalación, adecuación y puesta en marcha de sistemas hidráulicos y sanitarios, garantizando funcionalidad, seguridad y durabilidad. Entre nuestras especialidades se destacan:`,
    bullets: [
      "Instalación de aparatos sanitarios de bajo consumo para promover la eficiencia hídrica.",
      "Optimización del uso del agua en sistemas de riego.",
      "Montaje de redes hidráulicas y sanitarias: agua potable, aguas residuales y aguas lluvias.",
      "Conexiones hidráulicas para cuartos de bombas y equipos de presión.",
      "Cumplimiento estricto de la norma técnica colombiana NTC 1500.",
    ],
  },
  {
    slug: "mobiliario",
    name: "MOBILIARIO",
    description: `Ofrecemos soluciones de mobiliario funcional, ergonómico y estético, adaptadas a espacios administrativos, asistenciales, educativos e institucionales. Diseñamos e instalamos:`,
    bullets: [
      "Recepciones, salas de juntas y estaciones de trabajo.",
      "Escritorios, mesas auxiliares, sillas operativas y ejecutivas.",
      "Armarios, cajoneras, archivadores y lockers.",
      "Mobiliario clínico y asistencial: estaciones de enfermería, muebles para salas de espera y carros para insumos.",
      "Muebles escolares y especiales a medida.",
      "Acabados en melamina, fórmica, metálicos o tapizados, según el uso y diseño del espacio.",
    ],
  },
  {
    slug: "sistemas-electricos",
    name: "SISTEMAS ELÉCTRICOS",
    description: `Diseñamos, instalamos y realizamos mantenimiento de redes eléctricas internas y externas, garantizando la seguridad de las personas, los bienes y el entorno. Nuestros servicios cumplen con la normativa vigente (NTC 2050, RETIE y RETILAP) e incluyen:`,
    bullets: [
      "Redes eléctricas de baja y media tensión.",
      "Instalaciones interiores y exteriores para todo tipo de edificaciones.",
      "Canalizaciones, tableros eléctricos y sistemas de puesta a tierra.",
      "Iluminación técnica y de emergencia con eficiencia energética.",
      "Diagnóstico, corrección y prevención de riesgos eléctricos.",
    ],
  },
  {
    slug: "espacios-publicos",
    name: "ESPACIOS PÚBLICOS",
    description: `Desarrollamos y mejoramos espacios públicos funcionales, seguros y accesibles, promoviendo el bienestar comunitario y la sostenibilidad urbana. Nuestros servicios incluyen:`,
    bullets: [
      "Construcción y adecuación de campos y canchas deportivas.",
      "Instalación de cerramientos, barandas y señalización.",
      "Construcción de andenes y senderos peatonales.",
      "Suministro e instalación de juegos infantiles.",
      "Empradización y adecuación de zonas verdes.",
      "Instalación y mantenimiento de mobiliario urbano: bancas, canecas, postes, entre otros.",
    ],
  },
  {
    slug: "gas-natural",
    name: "GAS NATURAL",
    description: `Ofrecemos soluciones completas en sistemas de gas natural, desde el diseño hasta el mantenimiento, garantizando eficiencia, seguridad y cumplimiento normativo. Nuestros servicios incluyen:`,
    bullets: [
      "Asesoría técnica especializada.",
      "Suministro e instalación de redes nuevas de gas natural.",
      "Redistribución y adecuación de puntos existentes.",
      "Instalación de gasodomésticos y equipos industriales.",
      "Mantenimiento preventivo y correctivo de sistemas.",
      "Todas nuestras actividades se realizan conforme a la norma NTC 2505.",
    ],
  },
  {
    slug: "vidrio-aluminio",
    name: "VIDRIO ALUMINIO",
    description: `Diseñamos e instalamos soluciones en vidrio, aluminio y estructuras metálicas, adaptadas a entornos comerciales, institucionales y residenciales. Ofrecemos:`,
    bullets: [
      "Divisiones interiores en aluminio-vidrio o acero-vidrio, con acabados funcionales y estéticos.",
      "Suministro, instalación y mantenimiento de puertas en aluminio, vidrio, madera, metal y materiales reciclados.",
      "Integración de accesorios: chapas, brazos hidráulicos, bisagras, marcos y cerraduras.",
      "Servicios de carpintería metálica para estructuras, cerramientos, pasamanos, entre otros.",
    ],
  },
];
